import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import { authEntity } from "@/models/modules/auth/entity";
import AppConfig from "../core/app.config";
import { addToast } from "@/api/handler";
import { profileEntity } from "@/models/modules/profile/entity";
import { $getCustomerCompany } from "@/api/mainPage/company/company";

Vue.use(VueRouter);

let isLoaded: boolean = true;

let router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: "smooth"
			};
		}
		if (!to.matched.some(m => m.meta.scrollToTop)) {
			return { x: 0, y: 0 };
		}
	}
});

router.beforeEach(async (to, from, next) => {

	if (AppConfig.availableRouteNames
		&& AppConfig.availableRouteNames.length
		&& !AppConfig.availableRouteNames.includes(to.name as string)) {

		addToast("Раздел \"" + (to.meta?.value || to.name || to.path) + "\" находится в разработке", "error");

		if (process.env.NODE_ENV === "development") console.warn("Unavailable route", to);

		return;
	}

	const isAuth: boolean = AppConfig.authEnabled
		? authEntity.isAuth
		: true;

	if (isAuth !== authEntity.authedState) authEntity.authedState = isAuth;

	if (to.name !== "Login" && isAuth && isLoaded) {
		await $getCustomerCompany({ transliteration: "true" }).then((r: any) => {
			isLoaded = false;

			profileEntity.company = r;

			const companyUpdate = r?.employeeInfo?.find((v: any) => v.branches.find((i: any) => i.isCurrent === true));
			const companyBranchUpdate = companyUpdate?.branches?.find((i: any) => i.isCurrent);

			profileEntity.profileData = {
				flCrmId: r.flCrmId,
				ulCrmId: companyUpdate?.ulCrmId,
				ulName: companyUpdate?.ulName,
				role: companyUpdate?.role,
				mfoUl: companyBranchUpdate?.mfoUl,
				nciId: companyBranchUpdate?.nciId,
				ulCity: companyUpdate?.ulCity,
				ulAddress: companyUpdate?.ulAddress,
				ulInn: companyUpdate?.ulInn,
				ulPinfl: companyUpdate?.ulPinfl,
				customerType: r.customerType
			};
		});
	}

	if (to.meta!.authRequired === false) {

		next(isAuth ? { name: "Home" } : undefined);

	} else if (!isAuth) {

		next({ name: "Login" });

	} else {

		if (Array.isArray(to.meta!.roles) && !to.meta!.roles.includes(profileEntity?.profileData?.role))
			next({ name: "Home" });
		else
			next();

	}

});


export default router;
